import React from "react";
import BookSearch from "./components/BookSearch";
import "./App.css";

function App() {
  return (
    <div className="app-container">
      <BookSearch />
    </div>
  );
}

export default App;
